import { render, staticRenderFns } from "./integralConfigManageList.vue?vue&type=template&id=465ce2e8&scoped=true"
import script from "./integralConfigManageList.vue?vue&type=script&lang=js"
export * from "./integralConfigManageList.vue?vue&type=script&lang=js"
import style0 from "./integralConfigManageList.vue?vue&type=style&index=0&id=465ce2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ce2e8",
  null
  
)

export default component.exports